module.exports = __webpack_public_path__ + "img/back.3f6be21b.svg";